/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';

const options = {
    rootMargin: '100px 0px',
    threshold: 0.1
};

const fetchImage = (url) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = resolve;
        image.onerror = reject;
    });
};

const handleInlineIntersection = (entries, observer) => {
    entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
            const src = typeof entry.target.dataset.src === 'string' ? entry.target.dataset.src : entry.target.src;
            const styleAttribute = typeof entry.target.dataset.styleAttribute === 'string' ? entry.target.dataset.styleAttribute : '--header-image-url';
            fetchImage(src).then(() => {
                entry.target.setAttribute('style', `${styleAttribute}: url("${src}");`);
                observer.unobserve(entry.target);
            });
        }
    });
};



document.addEventListener("DOMContentLoaded", function () {
    try {
        for (let it of document.getElementsByClassName('navbar-toggle')) {
            it.addEventListener('click', () => {
                if (document.getElementById('navMenu')){
                    document.getElementById('navMenu').classList.toggle('in');
                }
            });
        }
    } catch (e) {}

    let chatHint = document.getElementById('chatHintIcon');
    if (chatHint) chatHint.addEventListener('click', showHint, false);


    /*
     * LAZY LOAD IMAGES
     */
    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
                const src = entry.target.dataset.src;
                if (src) {
                    fetchImage(src).then(() => {
                        entry.target.src = src;
                        observer.unobserve(entry.target);
                    });
                }
            }
        });
    };

    let observer = new IntersectionObserver(handleIntersection, options);
    let images = document.querySelectorAll('img.lazy');
    Array.from(images).forEach(img => {
        observer.observe(img);
    });


    /**
     * LAZY LOAD BACKGROUND IMAGES
     */
    function handleImageBackgroundIntersection(entries) {
        entries.map((entry) => {
            if (entry.isIntersecting) {
                entry.target.style.backgroundImage = entry.target.dataset.src;
                entry.target.classList.remove('lazy-background');
                observer.unobserve(entry.target);
            }
        });
    }

    const bgImages = document.querySelectorAll('.lazy-background');
    const bgImageObserver = new IntersectionObserver(handleImageBackgroundIntersection);
    bgImages.forEach(image => bgImageObserver.observe(image));


    /**
     * LAZY LOAD BACKGROUND VIDEO IMAGES
     */
    const handleVideoImageBackgroundIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
                const src = typeof entry.target.dataset.src === 'string' ? entry.target.dataset.src : entry.target.src;
                fetchImage(src).then(() => {
                    if (entry.target.className.indexOf('youtube') !== -1 || entry.target.className.indexOf('cover') !== -1) {
                        entry.target.setAttribute('style', "background-image: url('" + src + "');background-position:center;background-size:cover;");
                    } else {
                        entry.target.setAttribute('style', "background-image: url('" + src + "');");
                    }
                    observer.unobserve(entry.target);
                });
            }
        });
    };

    let bgVideoImageObserver = new IntersectionObserver(handleVideoImageBackgroundIntersection, options);
    let bgVideoImages = document.querySelectorAll('.lazy-video-image-background');
    Array.from(bgVideoImages).forEach( img => {
        bgVideoImageObserver.observe(img);
    });


    /**
    * LAZY SET INLINE STYLE
    */
    let inlineObserver = new IntersectionObserver(handleInlineIntersection, options);
    let inlineImages = document.querySelectorAll('.lazy-style-attribute');
    Array.from(inlineImages).forEach( target => {
        inlineObserver.observe(target);
    });


    /**
    * LAZY LOAD MOVIES
    */
    let youtube = document.getElementsByClassName("youtube");
    Array.from(youtube).forEach(function (ytNode) {
        let btn = ytNode.getElementsByClassName('play-button')[0];
        btn.addEventListener( "click", function() {
            let iframe = document.createElement( "iframe" );
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute('class', 'embed-responsive-item');
            if (ytNode.dataset.embed.indexOf('?') !== -1) {
                iframe.setAttribute( "src", ytNode.dataset.embed +"&autoplay=1" );
            } else {
                iframe.setAttribute( "src", ytNode.dataset.embed +"?autoplay=1" );
            }

            ytNode.innerHTML = "";
            ytNode.appendChild(iframe);
        });
    });
});

window.showHint = function () {
    document.getElementById('chatHintMessage').removeAttribute('style');
    document.getElementById('chatHintIcon').setAttribute('style', 'display: none');
    setTimeout(function () {
        document.getElementById('chatHintMessage').setAttribute('style', 'display: none');
        document.getElementById('chatHintIcon').removeAttribute('style');
    }, 4000);
};
